// @flow

/**
 * Export `boxShadows`.
 */

export const boxShadows = {
  default: '0 4px 4px 0 rgba(105,122,137,0.05), 0 6px 18px 0 rgba(105,122,137,0.1), 0 0 1px 0 rgba(105,122,137,0.5)'
};
